var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventMain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 62,
    viewBox: "0 0 47 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8211_19025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.26758 13.3452C8.77118 20.2588 21.8737 41.0334 21.3405 43.4271L34.4823 46.3312C31.9291 38.7452 34.7678 24.763 36.8725 7.74163L1.26758 13.3452Z",
    fill: "url(#paint0_linear_8211_19025)",
    fillOpacity: 0.48
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_8211_19025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0793 34.0548L40.3279 39.05L26.7332 47.4281L13.7991 37.434L25.239 33.8348C26.5005 33.4379 27.8664 33.5162 29.0793 34.0548Z",
    fill: "url(#paint1_linear_8211_19025)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_8211_19025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.644 33.1755C27.3601 32.5417 25.88 32.4374 24.5259 32.8856L14.4615 36.2181L13.2727 35.6101L24.5257 31.8853C25.8798 31.4371 27.3599 31.5414 28.6438 32.1752L39.8753 37.7199L38.6805 38.1298L28.644 33.1755Z",
    fill: "url(#paint2_linear_8211_19025)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9494 35.7876C32.2376 35.1206 33.0945 35.2858 33.1999 36.0286L33.3372 36.9964C33.3844 37.3286 33.6091 37.5907 33.894 37.6456L34.7237 37.8055C35.3606 37.9282 35.5024 38.9277 34.9307 39.2641L34.1858 39.7023C33.9301 39.8527 33.7889 40.1795 33.836 40.5117L33.9733 41.4795C34.0787 42.2224 33.3094 42.6749 32.8507 42.14L32.253 41.4431C32.0478 41.2038 31.7358 41.1437 31.4801 41.2941L30.7352 41.7324C30.1634 42.0688 29.5462 41.349 29.8344 40.682L30.2099 39.813C30.3388 39.5147 30.2872 39.1508 30.082 38.9115L29.4843 38.2146C29.0256 37.6797 29.4134 36.7822 30.0503 36.9049L30.88 37.0648C31.1648 37.1197 31.445 36.9549 31.5739 36.6566L31.9494 35.7876Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1448 48.9936C39.1128 49.3699 38.8715 49.6925 38.521 49.8272L26.7254 54.363C26.4533 54.4676 26.1471 54.4464 25.8878 54.3051L15.0462 48.3955C14.7304 48.2234 14.5275 47.8972 14.5138 47.5397L14.0996 36.7281L26.9157 42.5837L40.0482 38.3633L39.1448 48.9936Z",
    fill: "url(#paint3_linear_8211_19025)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4301 26.1603C16.3678 25.4456 17.2742 25.0832 17.7529 25.6315L18.703 26.7198C18.9171 26.965 19.266 27.0495 19.5672 26.929L20.9044 26.3944C21.578 26.1251 22.2221 26.8628 21.8443 27.471L21.0943 28.6783C20.9253 28.9503 20.9559 29.3004 21.1699 29.5456L22.1201 30.634C22.5987 31.1823 22.0904 32.0006 21.3782 31.8282L19.9646 31.486C19.6461 31.4089 19.3161 31.5409 19.1471 31.8129L18.3972 33.0201C18.0194 33.6284 17.0611 33.3964 16.9988 32.6816L16.8751 31.2629C16.8472 30.9432 16.6127 30.6746 16.2942 30.5975L14.8806 30.2553C14.1684 30.0829 14.0846 29.1212 14.7582 28.8518L16.0954 28.3172C16.3966 28.1967 16.5817 27.8988 16.5539 27.5791L16.4301 26.1603Z",
    fill: "#D7E6F3",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4829 14.744C33.7822 14.1521 34.6697 14.2996 34.7781 14.9593L34.9687 16.1188C35.0171 16.4138 35.2497 16.6467 35.5447 16.6958L36.7041 16.8885C37.3637 16.9981 37.5096 17.8857 36.917 18.1838L35.8753 18.7077C35.6103 18.841 35.4637 19.131 35.5122 19.426L35.7027 20.5855C35.8111 21.2452 35.0137 21.6462 34.5391 21.1707L33.7047 20.335C33.4925 20.1224 33.1693 20.0687 32.9042 20.202L31.8626 20.7259C31.27 21.024 30.6313 20.3842 30.9306 19.7923L31.4566 18.7519C31.5904 18.4872 31.5373 18.164 31.325 17.9514L30.4907 17.1157C30.016 16.6402 30.4187 15.8438 31.0783 15.9534L32.2377 16.1461C32.5327 16.1951 32.8231 16.0491 32.9569 15.7844L33.4829 14.744Z",
    fill: "#D7E6F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.245 5.77853C15.5561 5.16336 16.4785 5.31667 16.5911 6.00227L17.0861 9.01409C17.1365 9.3207 17.3782 9.56279 17.6848 9.61375L20.6965 10.1143C21.3821 10.2283 21.5337 11.1507 20.9177 11.4605L18.2119 12.8213C17.9365 12.9599 17.7841 13.2613 17.8345 13.5679L18.3295 16.5797C18.4422 17.2653 17.6134 17.6821 17.1201 17.1879L14.9529 15.0172C14.7322 14.7962 14.3964 14.7404 14.1209 14.8789L11.4151 16.2397C10.7992 16.5495 10.1354 15.8846 10.4465 15.2695L11.8128 12.567C11.9519 12.2919 11.8967 11.956 11.6761 11.735L9.50884 9.56424C9.0155 9.0701 9.43399 8.24239 10.1195 8.35634L13.1312 8.85691C13.4378 8.90787 13.7396 8.7561 13.8787 8.48099L15.245 5.77853Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8211_19025",
    x: 1.01758,
    y: 7.4917,
    width: 36.1045,
    height: 39.0896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_8211_19025"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_8211_19025",
    x: 13.7988,
    y: 33.5852,
    width: 26.5293,
    height: 14.3853,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5423
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0846
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8211_19025"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_8211_19025",
    x: 13.2725,
    y: 31.6111,
    width: 26.6025,
    height: 7.0611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5423
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0846
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8211_19025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8211_19025",
    x1: 13.0025,
    y1: 9.44592,
    x2: 31.3577,
    y2: 44.5753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.326923,
    stopColor: "#ECF3F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8211_19025",
    x1: 27.8187,
    y1: 43.2968,
    x2: 27.7436,
    y2: 33.6673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F96FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8211_19025",
    x1: 13.5825,
    y1: 37.677,
    x2: 39.5199,
    y2: 37.2235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461538,
    stopColor: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8211_19025",
    x1: 40.5341,
    y1: 35.8743,
    x2: 30.973,
    y2: 67.3049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970565,
    stopColor: "#5097FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventMain);
export default __webpack_public_path__ + "static/media/event-main.9f09d29060805ec05ecac3c84e753b79.svg";
export { ForwardRef as ReactComponent };